import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { CoinGeckoContext } from './coingecko.context';

const coingeckoClient = axios.create({
  baseURL: 'https://api.coingecko.com/api/v3/simple/price',
});

interface CoinGeckoPriceResponse {
  [tokenId: string]: {
    usd: number;
    eth: number;
  };
}

const getTokenRates = async (tokenIds: string[]) => {
  const tokenRateResponse = await coingeckoClient.request<
    any,
    AxiosResponse<CoinGeckoPriceResponse>
  >({
    method: 'GET',
    params: {
      ids: tokenIds.join(','),
      vs_currencies: ['usd', 'eth'].join(','),
    },
  });

  const tokenRatesData = tokenRateResponse.data;

  const tokenRates = tokenIds.map(tokenId => tokenRatesData[tokenId]);
  return tokenRates;
};

export const CoinGeckoContextProvider: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [starsUsdRate, setStarsUsdRate] = useState(1);
  const [starsEthRate, setStarsEthRate] = useState(1);
  const [ethUsdRate, setEthUsdRate] = useState(1);
  const [ethStarsRate, setEthStarsRate] = useState(1);
  const [bnbUsdRate, setBnbUsdRate] = useState(1);
  const [bnbStarsRate, setBnbStarsRate] = useState(1);

  const handleGetRates = async () => {
    const [starsRate, ethRate, bnbRate] = await getTokenRates([
      'mogul-productions-2',
      'ethereum',
      'binancecoin',
    ]);

    setStarsUsdRate(starsRate.usd);
    setStarsEthRate(starsRate.eth);
    setEthUsdRate(ethRate.usd);
    setEthStarsRate((1 / ethRate.usd) * starsRate.usd);
    setBnbUsdRate(bnbRate.usd);
    setBnbStarsRate((1 / bnbRate.usd) * starsRate.usd);
  };

  useEffect(() => {
    void handleGetRates();
  }, []);

  return (
    <CoinGeckoContext.Provider
      value={{
        starsUsdRate,
        starsEthRate,
        ethUsdRate,
        ethStarsRate,
        bnbUsdRate,
        bnbStarsRate,
        handleGetRates,
      }}
    >
      {children}
    </CoinGeckoContext.Provider>
  );
};
